module.exports = __webpack_public_path__ + "static/media/r5.a227ff0a.png";